import React, { useState, useEffect } from 'react'
import { uploaderIsDisabled, translateLabel, getTiffThumb } from './utils'

export interface Props {
  uploader: any
  className?: string
  preDefinedLabels?: any[]
  onClick?: () => void
}

function AssetDeliveryAsset({
  uploader,
  className,
  preDefinedLabels = [],
  ...rest
}: Props) {
  const [preview, setPreview] = useState<string>(uploader.asset?.image?.thumbUrl)

  useEffect(() => {
    if (uploader.asset?.image?.thumbUrl) {
      setPreview(uploader.asset.image.thumbUrl)
    }
    else if (uploader.file) {
      if (uploader.file.type === 'image/jpeg') {
        setPreview(URL.createObjectURL(uploader.file))
      }
      else {
        getTiffThumb(uploader.file).then(setPreview)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function handleImageRef(ref: HTMLImageElement | null) {
    if (!ref) return
    ref.onload = () => {
      if (preview && uploader?.file?.type === 'image/jpeg') {
        URL.revokeObjectURL(preview)
      }
    }
  }

  const labels = uploader.asset.labels

  const classNames = ['asset-delivery-asset']
  const labelsClassNames = ['labels']
  if (className) classNames.push(className)
  if (uploader.error) classNames.push('failed')
  if (uploaderIsDisabled(uploader)) classNames.push('disabled')
  if (labels && labels.length === 0) labelsClassNames.push('empty')

  return (
    <div className={classNames.join(' ')} {...rest}>
      <div className="file-preview">
        {preview && (
          <img draggable={false} ref={handleImageRef} src={preview} alt="" />
        )}
        {Array.isArray(labels) && (
          <div className={labelsClassNames.join(' ')}>
            {labels.length === 0
              ? 'Ikke merket'
              : labels.map(l => translateLabel(l, preDefinedLabels)).join(', ')
            }
          </div>
        )}
      </div>

      {uploader.error && (
        <span
          className="error"
          title="Denne opplastingen feilet. Slett filen og forsøk på nytt"
        >
          !
        </span>
      )}
    </div>
  )
}

export default AssetDeliveryAsset
